import { render, staticRenderFns } from "./AdmissionOlderDetailAdd.vue?vue&type=template&id=45237293&scoped=true"
import script from "./AdmissionOlderDetailAdd.vue?vue&type=script&lang=js"
export * from "./AdmissionOlderDetailAdd.vue?vue&type=script&lang=js"
import style0 from "./AdmissionOlderDetailAdd.vue?vue&type=style&index=0&id=45237293&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45237293",
  null
  
)

export default component.exports